import { createBrowserRouter, Navigate } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { Dashboard } from '@/pages/Dashboard';
import { MeetingRoom } from '@/pages/MeetingRoom';
import { MeetingDetails } from '@/pages/MeetingDetails';
import { MeetingsPage } from '@/pages/MeetingsPage';
import { AdminPanel } from '@/pages/AdminPanel';
import { TemplatesPanel } from '@/pages/TemplatesPanel';
import { LLMModelsPanel } from '@/pages/LLMModelsPanel';
import { ProtectedRoute } from '@/components/Layout/ProtectedRoute';
import { AppLayout } from '@/components/Layout/AppLayout';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AppLayout>
        <HomePage />
      </AppLayout>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <AppLayout>
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '/admin',
    element: (
      <AppLayout>
        <ProtectedRoute requireRole="admin">
          <AdminPanel />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '/templates',
    element: (
      <AppLayout>
        <ProtectedRoute requireRole="admin">
          <TemplatesPanel />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '/llm-models',
    element: (
      <AppLayout>
        <ProtectedRoute requireRole="admin">
          <LLMModelsPanel />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '/room/:code',
    element: (
      <AppLayout>
        <ProtectedRoute>
          <MeetingRoom />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '/meetings',
    element: (
      <AppLayout>
        <ProtectedRoute>
          <MeetingsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '/meetings/:roomCode',
    element: (
      <AppLayout>
        <ProtectedRoute>
          <MeetingDetails />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
